var cov_104cfsunli = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Image/events.tsx",
      hash = "23a7b2357069c3c31ae4dbc70230920ec94082f2",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Image/events.tsx",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 17,
          column: 51
        }
      },
      "1": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 55
        }
      },
      "2": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 84
        }
      },
      "3": {
        start: {
          line: 19,
          column: 41
        },
        end: {
          line: 19,
          column: 84
        }
      },
      "4": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 18
        }
      },
      "5": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 24,
          column: 31
        }
      },
      "6": {
        start: {
          line: 24,
          column: 24
        },
        end: {
          line: 24,
          column: 31
        }
      },
      "7": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 33
        }
      },
      "8": {
        start: {
          line: 28,
          column: 17
        },
        end: {
          line: 28,
          column: 33
        }
      },
      "9": {
        start: {
          line: 30,
          column: 27
        },
        end: {
          line: 30,
          column: 48
        }
      },
      "10": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 31,
          column: 43
        }
      },
      "11": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 41
        }
      },
      "12": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 33,
          column: 45
        }
      },
      "13": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 35,
          column: 18
        }
      },
      "14": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 39,
          column: 47
        }
      },
      "15": {
        start: {
          line: 39,
          column: 30
        },
        end: {
          line: 39,
          column: 47
        }
      },
      "16": {
        start: {
          line: 40,
          column: 14
        },
        end: {
          line: 40,
          column: 28
        }
      },
      "17": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 42,
          column: 48
        }
      },
      "18": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 44,
          column: 85
        }
      }
    },
    fnMap: {
      "0": {
        name: "close",
        decl: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 15,
            column: 14
          }
        },
        loc: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 15
      },
      "1": {
        name: "keyClose",
        decl: {
          start: {
            line: 23,
            column: 9
          },
          end: {
            line: 23,
            column: 17
          }
        },
        loc: {
          start: {
            line: 23,
            column: 36
          },
          end: {
            line: 25,
            column: 1
          }
        },
        line: 23
      },
      "2": {
        name: "getContainer",
        decl: {
          start: {
            line: 27,
            column: 9
          },
          end: {
            line: 27,
            column: 21
          }
        },
        loc: {
          start: {
            line: 27,
            column: 24
          },
          end: {
            line: 36,
            column: 1
          }
        },
        line: 27
      },
      "3": {
        name: "events",
        decl: {
          start: {
            line: 38,
            column: 24
          },
          end: {
            line: 38,
            column: 30
          }
        },
        loc: {
          start: {
            line: 38,
            column: 83
          },
          end: {
            line: 45,
            column: 1
          }
        },
        line: 38
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 84
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 84
          }
        }, {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 84
          }
        }],
        line: 19
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 6
          },
          end: {
            line: 19,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 6
          },
          end: {
            line: 19,
            column: 15
          }
        }, {
          start: {
            line: 19,
            column: 19
          },
          end: {
            line: 19,
            column: 39
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 31
          }
        }, {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 31
          }
        }],
        line: 24
      },
      "3": {
        loc: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 33
          }
        }, {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 33
          }
        }],
        line: 28
      },
      "4": {
        loc: {
          start: {
            line: 38,
            column: 70
          },
          end: {
            line: 38,
            column: 81
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 38,
            column: 80
          },
          end: {
            line: 38,
            column: 81
          }
        }],
        line: 38
      },
      "5": {
        loc: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 47
          }
        }, {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 47
          }
        }],
        line: 39
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0],
      "5": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Image/events.tsx";
import React from 'react';
import ReactDOM from 'react-dom';
import Gallery from './Gallery';
import { getDefaultContainer } from '../config';
import { imageClass } from './styles';
var container;

function close() {
  cov_104cfsunli.f[0]++;
  cov_104cfsunli.s[0]++;
  // eslint-disable-next-line
  document.removeEventListener('keydown', keyClose);
  cov_104cfsunli.s[1]++;
  ReactDOM.unmountComponentAtNode(container);
  cov_104cfsunli.s[2]++;

  if ((cov_104cfsunli.b[1][0]++, container) && (cov_104cfsunli.b[1][1]++, container.parentNode)) {
    cov_104cfsunli.b[0][0]++;
    cov_104cfsunli.s[3]++;
    container.parentNode.removeChild(container);
  } else {
    cov_104cfsunli.b[0][1]++;
  }

  cov_104cfsunli.s[4]++;
  container = null;
}

function keyClose(e) {
  cov_104cfsunli.f[1]++;
  cov_104cfsunli.s[5]++;

  if (e.keyCode === 27) {
    cov_104cfsunli.b[2][0]++;
    cov_104cfsunli.s[6]++;
    close();
  } else {
    cov_104cfsunli.b[2][1]++;
  }
}

function getContainer() {
  cov_104cfsunli.f[2]++;
  cov_104cfsunli.s[7]++;

  if (container) {
    cov_104cfsunli.b[3][0]++;
    cov_104cfsunli.s[8]++;
    return container;
  } else {
    cov_104cfsunli.b[3][1]++;
  }

  var defaultContainer = (cov_104cfsunli.s[9]++, getDefaultContainer());
  cov_104cfsunli.s[10]++;
  container = document.createElement('div');
  cov_104cfsunli.s[11]++;
  defaultContainer.appendChild(container);
  cov_104cfsunli.s[12]++;
  container.className = imageClass('gallery');
  cov_104cfsunli.s[13]++;
  return container;
}

export default function events(images) {
  var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_104cfsunli.b[4][0]++, 0);
  cov_104cfsunli.f[3]++;
  cov_104cfsunli.s[14]++;

  if (!Array.isArray(images)) {
    cov_104cfsunli.b[5][0]++;
    cov_104cfsunli.s[15]++;
    images = [images];
  } else {
    cov_104cfsunli.b[5][1]++;
  }

  var div = (cov_104cfsunli.s[16]++, getContainer());
  cov_104cfsunli.s[17]++;
  document.addEventListener('keydown', keyClose);
  cov_104cfsunli.s[18]++;
  ReactDOM.render(
  /*#__PURE__*/
  React.createElement(Gallery, {
    onClose: close,
    current: current,
    images: images,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 19
    }
  }), div);
}